var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fade-in"},[(_vm.isLoading)?_c('onboarding-loading',{attrs:{"loadingText":_vm.loadingMessage,"onErrorGoTo":'onboarding-error'}}):_c('ContractView',{attrs:{"ccbUrl":_vm.myCCBUrl},on:{"click":_vm.sendAcceptContract}}),_c('GenericModal',{attrs:{"name":"generic-modal","loadingText":"Contrato Assinado"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }